{
  "rememberMe": "Cofiwch fi",
  "signIn": "Mewngofnodi",
  "signUp": "Creu cyfrif",
  "signUpLink": "Nid oes gennych gyfrif?",
  "continueAsGuest": "Parhau fel gwestai",
  "forgotPassword": "Wedi anghofio'r cyfrinair",
  "forgotPasswordLink": "Wedi anghofio eich cyfrinair?",
  "setPassword": "Gosod cyfrinair",
  "codeVerification": "Dilysu cod",
  "verifyMessage": "Rydym wedi anfon cod dilysu i'ch cyfeiriad e-bost",
  "changePassword": "Newid cyfrinair",
  "signOut": "Allgofnodi",
  "deleteAccount": "Dileu cyfrif",
  "availableProfiles": "Proffiliau sydd ar gael",
  "selectProfile": "Dewis proffil",
  "noProfiles": "Dim proffiliau ar gael",
  "switchProfile": "Newid proffil",
  "alreadyHaveCode": "Oes gennych god dilysu eisoes?",
  "tempPassMessage": "Newidiwch eich cyfrinair dros dro",
  "mfa": {
    "settings": "Gosodiadau MFA",
    "SMS": "SMS",
    "TOTP": "Ap Dilysu",
    "noPreference": "Dim dewis",
    "enabledMFAMethods": "Dulliau MFA wedi'u galluogi",
    "preferredMFAMethod": "Dull MFA a ffefrir",
    "setupTOTPMFA": "Sefydlu MFA Ap Dilysu",
    "setupSMSMFA": "Sefydlu MFA SMS",
    "disableTOTPMFA": "Analluogi MFA Ap Dilysu",
    "disableSMSMFA": "Analluogi MFA SMS",
    "TOTPSetup": "Sefydlu Ap Dilysu",
    "SMSSetup": "Sefydlu SMS",
    "secretKey": "Allwedd gyfrinachol",
    "installAuthApp": "Gosodwch ap dilysu ar eich dyfais symudol",
    "addAnAccount": "Ychwanegu cyfrif",
    "scanQRCode": "Sganiwch y cod QR canlynol:",
    "or": "Neu...",
    "addSecretManually": "Ychwanegwch yr allwedd gyfrinachol i'ch ap dilysu â llaw:",
    "copySecretKey": "Copïo allwedd gyfrinachol",
    "regenSecretKey": "Ailgynhyrchu allwedd gyfrinachol",
    "ensureAccountCreated": "Gwnewch yn siŵr bod cyfrif '{appName}' wedi'i greu",
    "verifySetup": "Dilyswch eich gosodiad:",
    "done": "Wedi gorffen",
    "otpMessage": "Rhowch eich cod un-tro o'ch ap dilysu",
    "smsMessage": "Rydym wedi anfon cod dilysu atoch drwy SMS",
    "setupAuthAppMessage": "Angen sefydlu eich ap dilysu?",
    "signUpOptionalMobileMessage": "Bydd ychwanegu eich rhif ffôn symudol yn eich galluogi i ddefnyddio SMS ar gyfer dilysu aml-ffactor (MFA). Os na fyddwch yn ychwanegu rhif ffôn symudol, bydd angen i chi sefydlu MFA gan ddefnyddio ap dilysu (fel Google Authenticator) pan fyddwch yn mewngofnodi am y tro cyntaf.",
    "mfaSelectionHeader": "Dewis MFA",
    "mfaSelectionMessage": "Dewiswch sut rydych am dderbyn eich cod un-tro"
  },
  "ssoButtons": {
    "divider": "neu",
    "continueSso": "Parhau gyda SSO",
    "continueMs": "Parhau gyda Microsoft",
    "continueGoogle": "Parhau gyda Google",
    "continueApple": "Parhau gyda Apple"
  }
}
